/* ------------------------------------*\
    VARIABLE DECLARATION
\*------------------------------------*/
common = {

	setupCommon: function() {
		utils.checkWebpSupport();
		utils.setupHeight();

		if (utils.enableDebug) {
			utils.setupDebug();
		}
		if(utils.isMobile() || utils.isSmallScreen()){}else{}

		if(utils.isHome()){
			home.setupHome();
		}else if(utils.isSingleProduct()){
			product.setupProduct();
		}else if(utils.isCartPage()){
			cart.setupCart();
		}
	},
};

home = {
	setupHome: function() {
		utils.fadeInElement('li.product');
	},

};

product = {
	setupSwiper: function() {
		const $element = $( '.swiper-container' );

		let $next_button = $element.find( '.swiper-button-next' );
		let $prev_button = $element.find( '.swiper-button-prev' );

		if ( $next_button.length < 1 ) {
			$next_button = $element.parent().find( '.swiper-button-next' );
		}
		if ( $prev_button.length < 1 ) {
			$prev_button = $element.parent().find( '.swiper-button-prev' );
		}
		const $pagination = $element.parent().find( '.swiper-pagination' );
		const el = $element[ 0 ];
		// eslint-disable-next-line no-var
		var swiper = new Swiper( el,
			{
				// in order to trigger the on('init') method i need to have init: false,
				init: false,
				// Disable preloading of all images
				preloadImages: false,
				// Enable lazy loading
				lazy: {
				//  tell swiper to load images before they appear
					loadPrevNext: true,
					// amount of images to load
					loadPrevNextAmount: 3,
				},

				navigation: {
					nextEl: '.swiper-button-next',
					prevEl: '.swiper-button-prev',
				},

				// pagination: {
				// 	el: $pagination[ 0 ],
				// 	type: 'fraction',
				// 	clickable: false,
				// 	renderFraction( currentClass, totalClass ) {
				// 		const totalSlides = $( '.swiper-slide:not(.swiper-slide-duplicate)' ).length;
				// 		setTimeout( function() {
				// 			$( '.swiper-pagination-total' ).html( totalSlides );
				// 		}, 10 );
				// 		return '<span class="' + currentClass + '"></span> / <span class="' + totalClass + '"></span>';
				// 	},

				// },
				slidesPerView: 1,
				spaceBetween: 10,
				loop: false,
				centeredSlides: true,

				breakpoints: {
					768: {
						slidesPerView: 'auto',
						centeredSlides: false,
						spaceBetween: 10,
					},

				},

				on: {
					init() {

					},
					progress() {

					},
					slideChange() {

					},
					paginationUpdate( swiper, paginationEl ) {
						const totalSlides = $( '.swiper-slide:not(.swiper-slide-duplicate)' ).length;
						$( '.swiper-pagination-total' ).html( totalSlides );
					},
				},

			} );
		if ( utils.enableDebug && false ) {
			console.log( '--- Call to setupSwiper() from 00_commnon.js ---' );
			console.log( 'Param $element:' );
			console.log( $element );
			console.log( el );
			console.log( 'Variable $next_button:' );
			console.log( $next_button );
			console.log( 'Variable $prev_button:' );
			console.log( $prev_button );
			console.log( 'Variable pagination:' );
			console.log( $pagination );
			console.log( 'Variable swipper:' );
			console.log( swiper );

			console.log( '--- Call to setupSwiper() from 00_commnon.js ---' );
		}
		return swiper;
	},

	setupCartAjaxify: function() {
		$( '.single_add_to_cart_button' ).each( function( index ) {
			$( this ).on( 'click', function( e ) {
				e.preventDefault();

				const product_id = $( this ).attr( 'data-value' );
				const product_title = $( this ).attr( 'data-title' );
				const variation_id = $( this ).attr( 'data-variation' );
				// console.log( '--------------' );
				// console.log( product_id );
				// console.log( product_title );
				// console.log( variation_id );
				// console.log( this );
				// console.log( '--------------' );
				const quantity = 1;
				// return 0;
				// console.log(woocommerce_params.ajax_url);
				// console.log(woocommerce_params);
				if ( quantity > 0 ) {
					e.preventDefault();
					jQuery.ajax( {
						url: woocommerce_params.ajax_url,
						type: 'POST',
						data: 'action=mode_theme_update_mini_cart&product_id=' + product_id + '&variation_id=' + variation_id + '&quantity=' + quantity + '&mode=add_item',
						success( data ) {
							// console.log("SUCCESS!");
							// console.log(data);
							$( document.body ).trigger( 'update_checkout' );
							// update counter
							const $counter = $( '#mini-cart-count' );
							const currentQuantity = parseInt( $counter.html(), 10 );
							const newQuantity = currentQuantity + 1;
							$counter.text( newQuantity );
							$( '.p-product-added-feedback' ).fadeIn().delay( 3000 ).fadeOut();
						},
					} );

					return false;
				}
			} );
		} );
	},

	setupProduct: function(){
		const swiper = product.setupSwiper();

		swiper.on( 'init', function() {

		} );
		swiper.init();

		product.setupCartAjaxify();

		utils.fadeInElement('.fadeInElement');

	}
};

cart = {
	// With this method we check when the quantity changes
	setupCartUpdateQantity: function() {
		$( 'input.qty' ).off( 'change' ).on( 'change', function() {
			$( "[name='update_cart']" ).removeAttr( 'disabled' );
			$( "[name='update_cart']" ).trigger( 'click' );
		} );
	},

	// With this method we check when the form is updated so that we can keep updating the quantity after the first update of the form
	setupObserverFormChange: function() {
		if ( $( '.woocommerce-cart-form' ).length > 0 ) {
			const observer = new MutationObserver( function( mutationRecords ) {
				cart.setupCartUpdateQantity();
				cart.setupObserverFormChange();
			} );

			observer.observe( $( '.woocommerce-cart-form' )[ 0 ],
				{ // options:
					subtree: true, // observe the subtree rooted at myNode
					childList: true, // include information childNode insertion/removals
					attribute: true, // include information about changes to attributes within the subtree
				} );
		}
	},

	setupCart: function(){
		cart.setupCartUpdateQantity();
		cart.setupObserverFormChange();
	}
};

$( window ).on( 'load', () => {
	/*------------------------------------*\
        CALL TO FUNCTIONS
    \*------------------------------------*/
	console.log(
		'<!-- --------------------------------------------- -->\n' +
        '<!-- Code by AMA, http://ama.work (2022) 		-->\n' +
        '<!-- info@ama.work 				-->\n' +
        '<!-- Developer: David Penuela 				-->\n' +
        '<!-- --------------------------------------------- -->');

	common.setupCommon();

});
